import { toRefs, provide } from 'vue';
import { useModel } from '../../compositions/component-lib.esm15.js';

//
var script = {
  name: 'ButtonGroup',
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value
    } = toRefs(props);
    const selected = useModel(value, val => emit('input', val));
    function onChange(value) {
      selected.value = value;
    }
    provide('button-group', {
      isInGroup: true,
      selected,
      onChange
    });
    return {
      selected
    };
  }
};
export { script as default };